import React from 'react';
import Button from 'antd/es/button';

import { Header3 } from 'components/layout/headers';
import { ButtonContainer, PopupModal } from 'pages/booking/booking-details-page/discount-popup-modal/elements';

interface IDiscountPopupModal {
  error: string;
  open?: boolean;
  title: string;
  onOpenChange?: (open: boolean) => void;
  onCancel?: () => void;
}

export const BookingErrorModal = ({
  error,
  title,
  onCancel,
  open,
  onOpenChange = () => void 0,
}: IDiscountPopupModal) => {
  const handleCancel = () => {
    onCancel && onCancel();
    onOpenChange(false);
  };

  return (
    <PopupModal footer={null} open={open} mask={true} destroyOnClose onCancel={handleCancel}>
      <Header3 style={{ textAlign: 'center' }}>{title}</Header3>

      <div className="modal-text">{error}</div>

      <ButtonContainer style={{ justifyContent: 'center', marginTop: 24 }}>
        <Button size="large" className="cancel" onClick={handleCancel}>
          Got it
        </Button>
      </ButtonContainer>
    </PopupModal>
  );
};

